/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useGetFeedPermissions = (feed:any, userData:any) =>
{
	const feedManagement = useSelector((state:any) => state?.mysession?.configs?.feedManagement);

	const getPermission = useCallback((type:any) => // returns true if this is enabled
	{
		const isAdmin = userData?.empRole === 'admin';
		const isSuperAdmin = userData?.empRole === 'superAdmin';

		if (userData?.role === 'individual')
		{
			if ([ 'schedulePost', 'polls', 'occasions' ].includes(type)) return true;
			else return feed?.createdBy === userData?.userId || feed?.access?.relation?.[type];
		}
		else if ([ 'schedulePost', 'polls', 'occasions' ].includes(type))
		{ // options while creating feed
			// if (isSuperAdmin)
			// {
			// 	return true;
			// }

			if (isAdmin || isSuperAdmin)
			{
				return feedManagement?.feedsConfig?.admin?.[type];
			}

			return feedManagement?.feedsConfig?.employee?.[type];
		}
		const isFeedFromSameCompany = feed?.companyId === userData?.companyId;

		let isConfigEnabled;

		if (isFeedFromSameCompany)
		{
			// if (isSuperAdmin)
			// {
			// 	isConfigEnabled = true;
			// }
			if (isAdmin || isSuperAdmin)
			{
				isConfigEnabled = feed?.access?.admin?.[type];
			}
			else
			{
				isConfigEnabled = feed?.access?.employee?.[type];
			}
		}
		else
		{
			isConfigEnabled = feed?.access?.relation?.[type];
		}

		return isConfigEnabled;
	}, [ feed, feedManagement, userData ]);

	return getPermission;
};

export default useGetFeedPermissions;

// old code
// export const useGetFeedPermissionsOld = (feed:any, userData:any) =>
// {
// 	const feedManagement = useSelector((state:any) => state?.mysession?.configs?.feedManagement);

// 	const getPermission = useCallback((type:any) => // returns true if this is enabled
// 	{
// 		const isEnable = () =>
// 		{
// 			if (userData?.role === 'individual')
// 			{
// 				if ([ 'schedulePost', 'polls', 'occasions' ].includes(type)) return true;
// 				else return feed?.createdBy === userData?.userId || feed?.access?.relation?.[type];
// 			}
// 			else if ([ 'schedulePost', 'polls', 'occasions' ].includes(type)) // options while creating feed
// 			{
// 				return roleCondition(userData?.empRole)
// 					? feedManagement?.feedsConfig?.admin?.[type]
// 					: feedManagement?.feedsConfig?.employee?.[type];
// 			}
// 			const isFeedFromSameCompany = feed?.companyId === userData?.companyId;
// 			let isConfigEnabled = null;

// 			if (isFeedFromSameCompany)
// 			{
// 				if (roleCondition(userData?.empRole))
// 				{
// 					isConfigEnabled = feed?.access?.admin?.[type];
// 				}
// 				else
// 				{
// 					isConfigEnabled = feed?.access?.employee?.[type];
// 				}
// 			}

// 			return isConfigEnabled;
// 		};

// 		return isEnable;
// 	}, [ feed, feedManagement, userData ]);

// 	return getPermission;
// };